import {createFileRoute, Navigate} from '@tanstack/react-router';

/** Record a game moved into Social Games (its New game tab): old links land there. */
export const Route = createFileRoute('/_app/football/record')({
    component: RouteComponent,
});

function RouteComponent() {
    return <Navigate to="/football/social/" search={{tab: 'new'} as any} />;
}
